// extracted by mini-css-extract-plugin
export default {"container":"TabComponent_container__KCwT7","imgContainer":"TabComponent_imgContainer__AxfXA"};